<template>
  <div class="container-fluid">
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div class="page-content__header-description" style="display: flex; margin-bottom: 20px;">
        <h2 style="flex: 1;">Customer Management</h2>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <el-tabs v-model="activeTab">
              <can I="read" a="user">
                <el-tab-pane label="Customers" name="customer_list">
                  <Customers/>
                </el-tab-pane>
              </can>
              <can I="create" a="invoice">
                <el-tab-pane label="Invoices" name="invoices">
                  <Invoices/>
                </el-tab-pane>
              </can>
              <!-- <can I="read" a="device">
                <el-tab-pane label="User Devices" name="user_devices">
                  <Devices/>
                </el-tab-pane>
              </can> -->
              <can I="create" a="wallet">
                <el-tab-pane label="Transaction History" name="transaction_history">
                  <transaction-histories/>
                </el-tab-pane>
              </can>
              <!-- <can I='read' a='user'>
                  <el-tab-pane title="User Role Management">
                  <user-role/>
                  </el-tab-pane>
              </can>-->
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Customers from "../users/customers";
import Invoices from "../users/invoices";
import Devices from "../devices/List";
import transactionHistories from "../shs/Wallet";
import userRole from "../users/allow";
import RightBar from "../rightBar";
export default {
  name: "",
  components: {
    Customers,
    Devices,
    RightBar,
    transactionHistories,
    userRole,
    Invoices
  },
  data() {
    return {
      activeTab: "customer_list"
    };
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/submodules/customers.vue